import { StyledTooltip } from "../../components/toolltipComponent";
import { statusLabel } from "./taskHelpers";

const ymdToDMY = (ymd) => {
  if (!ymd) return "—";
  const s = String(ymd).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return s;
  return `${m[3]}/${m[2]}/${m[1]}`;
};

export const indicatorTableColumns = [
  { field: "description", description: "Tarea", header: "Actividad" },
  { field: "category", header: "Categ.", align: "center" },
  { field: "classification", header: "Clasif.", align: "center" },
  {
    field: "created_ymd",
    header: "Fecha de creación",
    align: "center",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">
        {ymdToDMY(rowData.created_ymd)}
      </p>
    )
  },
  {
    field: "planned_label",
    header: "Fecha planificada",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">{rowData.planned_label}</p>
    )
  },
  {
    field: "execution_label",
    header: "Fecha ejecución",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">{rowData.execution_label}</p>
    )
  },
  {
    field: "state_code",
    header: "Estado",
    columnType: "custom",
    render: (rowData) => {
      return <p className="table-default-column">{statusLabel(rowData)}</p>;
    }
  },
  { field: "actionButtons", columnType: "actionButtons" }
];

/** Columnas para el detalle de "Ejecutadas vs No planificadas": sin Fecha de creación, "Fecha asignada" en lugar de "Fecha planificada" */
export const indicatorTableColumnsUnplanned = [
  { field: "description", description: "Tarea", header: "Actividad" },
  { field: "category", header: "Categ.", align: "center" },
  { field: "classification", header: "Clasif.", align: "center" },
  {
    field: "planned_label",
    header: "Fecha asignada",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">{rowData.planned_label}</p>
    )
  },
  {
    field: "execution_label",
    header: "Fecha ejecución",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">{rowData.execution_label}</p>
    )
  },
  {
    field: "state_code",
    header: "Estado",
    columnType: "custom",
    render: (rowData) => {
      return <p className="table-default-column">{statusLabel(rowData)}</p>;
    }
  },
  { field: "actionButtons", columnType: "actionButtons" }
];

export const managementIndicatorComparativeComplianceBySectorTableColumns = [
  { field: "task_id", description: "id", header: "", columnType: "hide" },
  { field: "responsible", description: "Responsable", header: "Responsable" },
  {
    field: "planned_activities",
    header: "Actividades Planeadas",
    align: "center"
  },
  {
    field: "not_executed_activities",
    header: "Actividades sin Ejecutar",
    align: "center"
  },
  {
    field: "out_of_term_activities",
    header: "Actividades Fuera de Termino",
    align: "center"
  },
  {
    field: "deleted_activities",
    header: "Actividades Eliminadas",
    align: "center"
  },
  {
    field: "trend_pct",
    header: "Tendencia del Empleado",
    columnType: "custom",
   render: (rowData) => (
      <StyledTooltip
        title={
          <div >
            <div className="HContainer align-center">
              <p className="info-label-tooltip">Ejecutadas vs Planificadas</p>
              <span className="table-default-column ml-10">
                {rowData.trend_parts.executed_vs_projected + "%" + " / 40%"}
              </span>
            </div>
            <div className="HContainer align-center">
              <p className="info-label-tooltip">Ejecutadas vs No Planificadas</p>
              <span className="table-default-column ml-10">
                {rowData.trend_parts.executed_unplanned + "%" + " / 20%"}
              </span>
            </div>
            <div className="HContainer align-center">
              <p className="info-label-tooltip">Actividades Eliminadas</p>
              <span className="table-default-column ml-10">
                {rowData.trend_parts.deleted + "%" + " / 35%"}
              </span>
            </div>
            <div className="HContainer align-center">
              <p className="info-label-tooltip">Actividades Delegadas </p>
              <span className="table-default-column ml-10">
                {rowData.trend_parts.delegated + "%" + " / 5%"}
              </span>
            </div>
          </div>
        }
        followCursor
        disableInteractive
      >
        <p className="table-default-column">{rowData.trend_pct + "%"}</p>
      </StyledTooltip>
    )
  },
  { field: "actionButtons", columnType: "actionButtons" }
];

export const managementDetailsTaskColumns = [
  { field: "description", header: "Objetivos" },
  { field: "classification", header: "Clasif." },
  { field: "category", header: "Categ.", align: "center" },
  {
    field: "planned_start_date_ymd",
    header: "Fecha planificada",
    align: "center"
  },
  {
    field: "planned_end_date_ymd ",
    header: "Fecha ejecución",
    align: "center"
  },
  {
    field: "state_code",
    header: "Estado",
    columnType: "custom",
    render: (rowData) => {
      return <p className="table-default-column">{statusLabel(rowData)}</p>;
    }
  },
  { field: "actionButtons", columnType: "actionButtons" }
];

export const managementNoPlanningTableColumns = [
  { field: "task_id", description: "id", header: "", columnType: "hide" },
  { field: "responsible", description: "Responsable", header: "Responsable" },
  {
    field: "unplanned_activities",
    header: "Actividades No Planeadas",
    align: "center"
  },
  {
    field: "not_executed_activities",
    header: "Actividades sin Ejecutar",
    align: "center",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">
        {rowData.not_executed_activities !== undefined &&
        rowData.not_executed_activities !== null &&
        rowData.not_executed_activities !== ""
          ? Number(rowData.not_executed_activities)
          : 0}
      </p>
    )
  },
  {
    field: "out_of_term_activities",
    header: "Actividades Fuera de Termino",
    align: "center",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">
        {rowData.out_of_term_activities !== undefined &&
        rowData.out_of_term_activities !== null &&
        rowData.out_of_term_activities !== ""
          ? Number(rowData.out_of_term_activities)
          : 0}
      </p>
    )
  },
  {
    field: "deleted_activities",
    header: "Actividades Eliminadas",
    align: "center",
    columnType: "custom",
    render: (rowData) => (
      <p className="table-default-column">
        {rowData.deleted_activities !== undefined &&
        rowData.deleted_activities !== null &&
        rowData.deleted_activities !== ""
          ? Number(rowData.deleted_activities)
          : 0}
      </p>
    )
  },
  {
    field: "trend_pct",
    header: "Tendencia del Empleado",
    columnType: "custom",
    render: (rowData) => (
      <StyledTooltip
        title={
          <div >
            <div className="HContainer align-center">
              <p className="info-label-tooltip">Ejecutadas vs Planificadas</p>
              <span className="table-default-column ml-10">
                {rowData.trend_parts.executed_vs_projected + "%" + " / 40%"}
              </span>
            </div>
            <div className="HContainer align-center">
              <p className="info-label-tooltip">Ejecutadas vs No Planificadas</p>
              <span className="table-default-column ml-10">
                {rowData.trend_parts.executed_unplanned + "%" + " / 20%"}
              </span>
            </div>
            <div className="HContainer align-center">
              <p className="info-label-tooltip">Actividades Eliminadas</p>
              <span className="table-default-column ml-10">
                {rowData.trend_parts.deleted + "%" + " / 35%"}
              </span>
            </div>
            <div className="HContainer align-center">
              <p className="info-label-tooltip">Actividades Delegadas </p>
              <span className="table-default-column ml-10">
                {rowData.trend_parts.delegated + "%" + " / 5%"}
              </span>
            </div>
          </div>
        }
        followCursor
        disableInteractive
      >
        <p className="table-default-column">{rowData.trend_pct + "%"}</p>
      </StyledTooltip>
    )
  },
  { field: "actionButtons", columnType: "actionButtons" }
];
